import React, { useState, useEffect, useCallback } from "react";
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import IconButton from '@material-ui/core/IconButton';
import Button from "@material-ui/core/Button";
import Popover from '@material-ui/core/Popover';
import Switch from '@material-ui/core/Switch';
import { schedulingColumnSelectorStyles } from './styles';
import Separator from "../SchedulingComponent/Modal/CallMonitor/Separator";

export const SchedulingColumnSelector = ({
  columnsConfig,
  currentTab,
  updateSchedulingConfigColumnVisibility,
  changeSchedulingTableColumnVisibility
}) => {
  const classes = schedulingColumnSelectorStyles();
  const [checked, setChecked] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const isPopoverOpen = Boolean(anchorEl);

  const setAnchorToPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    cancelConfigModifications();
    setAnchorEl(null);
  };

  const populateComponentStateWithColumnConfig = useCallback((columns) => {
    let newChecked = [];
    columns.forEach(column => {
      newChecked.push(column.isVisible);
    });
    setChecked(newChecked);

  }, [setChecked]);

  useEffect(() => {
    if (columnsConfig[currentTab] !== undefined) {
      populateComponentStateWithColumnConfig(columnsConfig[currentTab].columns);
    }
  }, [populateComponentStateWithColumnConfig, currentTab, columnsConfig]);

  const updateSchedulingConfigColumnVisibilityState = (value, index) => {
    let newChecked = [...checked];
    newChecked[index] = value;
    setChecked(newChecked);
  };


  const cancelConfigModifications = () => {
    populateComponentStateWithColumnConfig(columnsConfig[currentTab].columns);
  };

  /**
   * Updates the store based on the current state of the switches
   */
  const populateChangesToStores = () => {
    let configPayload = [];
    columnsConfig[getCurrentColumnIndex()].columns.forEach((column, index) => {

      configPayload.push({
        ...column,
        isVisible: checked[index]
      });
    });
    updateSchedulingConfigColumnVisibility({currentTab, columns: configPayload});

    changeSchedulingTableColumnVisibility(configPayload);
  };

  /**
   * If current tab is greater than the lenght of the columns array,
   * it will return the first element of the array
   * @returns {int} List of columns to be displayed
   */
  const getCurrentColumnIndex = () => {
    if (currentTab <= columnsConfig.length - 1) {
      return currentTab;
    }
    return 0;
  }


  return (
    <>
      <IconButton
        id={"column-selector-component-open-button"}
        data-cy={"column-selector-component-open-button-cy"}
        color="primary"
        size="medium"
        aria-label="Selecione as colunas da tabela"
        onClick={(event) => setAnchorToPopover(event)}
      >
        <ViewComfyIcon size="large"></ViewComfyIcon>
      </IconButton>
      <Popover
        id={"column-selector-component-button"}
        data-cy={"column-selector-component-button-cy"}
        open={isPopoverOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className={classes.wrapper}>
          <div className={classes.heading}>
            <h3>Personalização da Grid</h3>
            <Separator />
          </div>
          <div className={classes.body}>
            {columnsConfig[getCurrentColumnIndex()]?.columns.map((column, index) => (
              column.name !== '' && column.tableSelector !== 'id' &&
              <div key={`${column.selector}-${index}`} className={classes.column}>
                <div className={classes.elementName}>{ column.name }</div>
                <div className={classes.elementSwitch}>
                  <Switch
                    color="primary"
                    checked={checked[index]}
                    onChange={() => {
                      updateSchedulingConfigColumnVisibilityState(!checked[index], index);
                    }}
                    id={`column-selector-component-switch-${column.tableSelector}`}
                    data-cy={`column-selector-component-switch-${column.tableSelector}-cy`}
                  ></Switch>
                </div>
              </div>
            ))}
          </div>
          <div className={classes.footer}>
            <Button
              className={`${classes.button} ${classes.cancelButton}`}
              variant="outlined"
              color="primary"
              onClick={handlePopoverClose}
              id={"column-selector-component-cancel-button"}
              data-cy={"column-selector-component-cancel-button-cy"}
            >
              Cancelar
            </Button>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={populateChangesToStores}
              id={"column-selector-component-save-button"}
              data-cy={"column-selector-component-save-button-cy"}
            >
              Salvar
            </Button>
          </div>
        </div>
      </Popover>
    </>
  );
}
